import axios from 'axios';

export const saleApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-sales`,
    headers: {
        'Content-Type': 'application/json'
    }
})